export default "__VITE_ASSET__DxMEOdZZ__"